import React, {useEffect, useRef, useState} from "react"
import WindowEventHelper from "../../lib/WindowEventHelper"
import keycode from "keycode"
import TSelectFilter from "../common/TSelectFilter"

export default function EntryHeaderSearchButton({searchOpen, searchKeyword, searchType, searchTypeOptions, placeholder,
                                                  onChangeSearchType, onOpen, onClose, onChangeKeyword, onSearch}) {

  const [searchable, setSearchable] = useState(false)
  const searchText = useRef(null)

  useEffect(() => {
    setSearchable(searchKeyword.length > 0)
  }, [searchKeyword])

  useEffect(() => {
    if (searchOpen) {
      setTimeout(() => { searchText.current.focus() }, 100)
    }
  }, [searchOpen])

  useEffect(() => {
    WindowEventHelper.add("keydown", handleWindowKeydown)

    return () => {
      WindowEventHelper.remove("keydown", handleWindowKeydown)
    }
  }, [])

  function handleWindowKeydown(e) {
    if (!searchOpen && (e.metaKey || e.ctrlKey) && keycode.isEventKey(e, 'f')) {
      e.preventDefault()
      onOpen()
    }
  }

  function handleKeyDown(e) {
    if (keycode.isEventKey(e, 'escape')) {
      onClose()
    }
  }

  return (
    <form className="search_blog" onSubmit={onSearch} onReset={onClose} onKeyDown={handleKeyDown}>
      <TSelectFilter
        className={"filter_search"} items={searchTypeOptions} selected={searchType}
        onSelect={(item, idx) => onChangeSearchType(item, idx)}
      />
      <input
        ref={searchText}
        type="text" className="tf_search"
        title="검색어 입력" placeholder={placeholder}
        value={searchKeyword}
        onChange={(e) => onChangeKeyword(e.target.value)}
      />
      <div className="info_search">
        <button type="button" className="btn_search" onClick={onOpen}>
          검색
          <span className="ico_blog ico_search"> 열기</span>
        </button>
        <button type="submit" className="btn_search btn_query" disabled={!searchable}>
          <span className="ico_blog ico_search">검색 하기</span>
        </button>
        <button type="reset" className="btn_del">닫기</button>
      </div>
    </form>
  )
}
